import React, { useState } from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import PricingSection from '../components/PricingSection';

/**
 * Same markup and styling as landing #pricing — avoids drift from duplicated cards/header.
 */
const SelectPlan = () => {
  const { user } = useAuth();
  const [selectedLocation, setSelectedLocation] = useState('us');

  return (
    <Layout>
      <div
        className="-mx-4 flex min-h-[calc(100vh-120px)] max-w-none w-[calc(100%+2rem)] flex-col justify-center sm:-mx-6 sm:w-[calc(100%+3rem)] lg:-mx-8 lg:w-[calc(100%+4rem)]"
      >
        <PricingSection
          user={user}
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
          showBadge={false}
        />
      </div>
    </Layout>
  );
};

export default SelectPlan;
